'use client';

import { useEffect } from 'react';

import { datadogLogs } from '@datadog/browser-logs';

import { DATADOG_SITE } from '../../config';

export function DatadogLogsProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    const token = process.env.NEXT_PUBLIC_DATADOG_CLIENT_TOKEN;
    const forwardErrors =
      (process.env.NEXT_PUBLIC_DD_FORWARD_ERRORS ?? 'false').toString().toLowerCase() ===
      'true';

    if (!token) return;
    if (globalThis.__DD_LOGS_INITIALIZED__) return;

    datadogLogs.init({
      clientToken: token,
      site: DATADOG_SITE,
      service: process.env.NEXT_PUBLIC_DD_SERVICE || 'ilotto-web-next',
      env: process.env.NEXT_PUBLIC_ENV || 'prod',
      forwardErrorsToLogs: forwardErrors,
      sessionSampleRate: 100,
    });

    globalThis.__DD_LOGS_INITIALIZED__ = true;
  }, []);

  return <>{children}</>;
}
